<template>
  <div class="order-list tt-custom-tab">
  <!--<form-create :rule="rules" v-model="form_obj" :option="options"></form-create>-->
    <!--<el-tabs  class="tt-custom-tab" v-model="type" @tab-click="tabChange()">
      <el-tab-pane v-for="(tab,index) in tabs" :key="index" :label="tab.label" :name="tab.name">
        <Orders v-on:totalCount="getTotalCount" v-if="type === tab.name" :type="type" :isSingle="isSingle" :expressList="expressList" :delegates="delegates"></Orders>
      </el-tab-pane>
    </el-tabs>-->
    <Orders v-on:totalCount="getTotalCount" :isSingle="isSingle" :expressList="expressList" :delegates="delegates" 
    :supportAccountList="supportAccountList" :supportEditAccountList="supportEditAccountList"></Orders>
    <Empty v-if="totalCount == 0 && !havKeyword" class="empty-content" :isSingle="isSingle"></Empty>
    <!-- <FloatingChat></FloatingChat> -->
  </div>
</template>

<script>
import FloatingChat from '../../../components/FloatingChat'
import Empty from './Empty'
import Orders from './Orders'
import { API_HOST, FILE_HOST } from '../../../services/constant.js'
import api from '../../../services/api.js'

export default {
  name: 'OrderList',
  created () {
    this.loginByWx()
    this.init()
  },
  components: {
    FloatingChat,
    Empty: Empty,
    Orders: Orders,
    
  },
  data () {
    return {
      /*form_obj:{},
      rules:[
        {
          type: "select",
          field: "cate_id1",
          title: "第一级",
          value: ["104"],
          col:{
            span:12
          },
          options: [
              {"value": "104", "label": "生态蔬菜", "disabled": false},
              {"value": "105", "label": "新鲜水果", "disabled": false},
          ],
          on:{
            change:(v)=>{
              this.form_obj.getRule('cate_id2').options=[{"value": "106", "label": "生态蔬菜", "disabled": false},
              {"value": "107", "label": "新鲜水果", "disabled": false},]
            }
          }
        },
        {
          type: "select",
          field: "cate_id2",
          title: "第二级",
          value: ["106"],
          col:{
            span:12
          },
          options: [],
        }
      ],
      options:{},*/
      expressList:[],
      delegates:[],
      supportAccountList:[],
      supportEditAccountList:[],
      type: 'all',
      form: {
        date: null
      },
      tabs: [],
      isSingle: false,
      totalCount: null,
      havKeyword: false,
      buyerTabs: [
        {label: '全部', name: 'all'},
        {label: '未完成', name: '11,12,13,14,15,16'},
        {label: '已完成', name: '20'},
        {label: '已取消', name: '30'}
      ],
      singleTabs: [
        {label: '全部', name: 'all'},
        {label: '待支付', name: '12'},
        {label: '待接单', name: '11'},
        {label: '待下单', name: '13,14'},
        {label: '待发货', name: '15'},
        {label: '待收货', name: '16'},
        {label: '已完成', name: '20'},
        {label: '已取消', name: '30'}
      ]
    }
  },
  methods: {
    init () {
      api.getExpressList(this,'').then((res)=>{
        this.expressList=res.body.result;
      })
      api.getShipDelegateList(this).then((res)=>{
        this.delegates=res.body.result;
      })
      api.getSupportAccountList(this).then((res)=>{
        this.supportAccountList=res.body.result;
      })
      api.getEditSupportAccountList(this).then((res)=>{
        this.supportEditAccountList=res.body.result;
      })
      this.type = null
      if (this.$route.fullPath.indexOf('buyer') > -1) {
        this.isSingle = true
        this.tabs = this.singleTabs
      } else {
        this.isSingle = false
        this.tabs = this.buyerTabs
      }
      setTimeout(() => {
        this.type = this.$route.query.type || 'all'
      })
    },
    tabChange() {
      this.totalCount = null
      this.$router.push(
        {
          path: this.$route.path,
          query: {
            type: this.type
          }
        }
      )
    },
    getTotalCount(data) {
      this.totalCount = data.totalCount
      this.havKeyword = data.havKeyword
    },
    async loginByWx () {
      let token =  this.$localStorage.get('token')
      if(!token){
        if(this.$route.query.random_string){
                let random_string = this.$route.query.random_string
                let res = await api.post(this, {
                  path: 'passport.php',
                  api: 'login_by_random',
                  data: {
                    random_string:random_string
                  },
                  loading: 'loading'
                })
                if(res.body.status == 'ok'){
                  this.$localStorage.set('token', res.body.result)
                   window.location.reload()
                }
              }
            }

      }
      
  },
  watch:{
    $route(val, oldVal){
      if (val.path !== oldVal.path) {
        this.init()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.empty-content {
  padding: 50px 0 50px;
}
</style>

<style lang="scss">
.order-list {
  margin-bottom: 80px;
  .el-tabs__content {
    overflow: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/List.vue